export default __webpack_public_path__ + "static/media/dropverse_carousel_1.png.webp";